import React, {Component} from 'react'
import {StyleSheet, View, Dimensions, ScrollView, TextInput} from 'react-native'
import {Text, Input, Button} from 'react-native-elements'

import {remove} from './network'
import TimePoint from './TimePoint'

import cloneDeep from 'lodash/cloneDeep'
const VIEW_WIDTH = Dimensions.get('window').width / 1.5
const INPUT_WIDTH = VIEW_WIDTH / 2.5

class Delete extends Component {
  constructor (props) {
    super(props)
    this.state = {
      timeLineData: [],
      title: '',
      url: '',
      isLoading: false,
    }
  }

  del = () => {
    this.setState({
      isLoading: true,
    })
    remove(this.props.id)
      .then(data => {
        this.setState({
          isLoading: false,
        })
        this.props.onDeleteCancelPress()
      })
      .catch(error => {
        this.setState({
          isLoading: false,
        })
        this.props.onCreateCancelPress()
      })
  }

  render () {
    return (
      <ScrollView style={styles.container}>
        <View style={styles.elementStyle}>
          <Text style={styles.flex}>Are you sure you want to delete?</Text>
          <View style={styles.deleteOrCancelButtonStyle}>
            <Button
              buttonStyle={styles.cancelButtonStyle}
              title={'CANCEL'}
              titleStyle={styles.cancelButtonTitleStyle}
              onPress={this.props.onDeleteCancelPress}
            />
            <Button
              buttonStyle={styles.deleteButtonStyle}
              title={'DELETE'}
              titleStyle={styles.deleteButtonTitleStyle}
              onPress={this.del}
              loading={this.state.isLoading}
            />
          </View>
        </View>
      </ScrollView>
    )
  }
}

const styles = StyleSheet.create({
  flex: {
    flex: 1,
  },
  deleteOrCancelButtonStyle: {
    flexDirection: 'row',
    width: VIEW_WIDTH,
    justifyContent: 'flex-end',
  },
  deleteButtonTitleStyle: {
    color: 'white',
    fontSize: 15,
  },
  cancelButtonTitleStyle: {
    color: 'black',
    fontSize: 15,
  },
  deleteButtonStyle: {
    width: 100,
    height: 30,
    backgroundColor: '#007599',
    borderRadius: 2,
    marginHorizontal: 20,
  },
  addMoreButtonStyle: {
    width: 100,
    height: 30,
    backgroundColor: 'green',
    borderRadius: 2,
    marginHorizontal: 20,
  },
  addMoreButtonTitleStyle: {
    color: 'white',
    fontSize: 15,
  },
  cancelButtonStyle: {
    width: 100,
    height: 30,
    backgroundColor: '#eeeeee',
    borderRadius: 2,
  },
  settingHeaderViewStyle: {
    flexDirection: 'row',
    width: VIEW_WIDTH,
    justifyContent: 'space-evenly',
  },
  settingHeaderTextStyle: {
    fontSize: 20,
    textTransform: 'uppercase',
  },
  removeButtonStyle: {backgroundColor: '#b53737', borderRadius: 20},
  timelineViewStyle: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  inputStyle: {
    width: INPUT_WIDTH,
    margin: 15,
  },
  inputViewStyle: {
    width: VIEW_WIDTH,
    margin: 15,
    flexDirection: 'row',
  },
  elementStyle: {
    width: VIEW_WIDTH,
    alignItems: 'center',
  },
  container: {
    flex: 1,
    backgroundColor: 'white',
    padding: 20,
    borderRadius: 20,
  },
})

export default Delete
